import { setOnboardingWalkthroughStep } from '@/redux/modules/walkthroughs/walkthroughs.reducer';
import { AppDispatch } from '@/redux/store';
import { AccountHolderWalkthroughSteps, DONE, NewAccountWalkthroughSteps } from '@/types/walkthroughs';

export const firstTimeWalkthroughSkip = (dispatch: AppDispatch) => () =>
    dispatch(setOnboardingWalkthroughStep(AccountHolderWalkthroughSteps.Returning));
export const accountHolderWalkthroughSkip = (dispatch: AppDispatch) => () =>
    dispatch(setOnboardingWalkthroughStep(NewAccountWalkthroughSteps.FirstTimeAnyPage));
export const newAccountWalkthroughSkip = (dispatch: AppDispatch) => () => dispatch(setOnboardingWalkthroughStep(DONE));
